import { TranslateService } from '@ngx-translate/core';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { SessionContextService } from 'projects/packcert-web/src/app/context/session-context.service';
import { DataProvider } from 'projects/packcert-web/src/app/providers/data.provider';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Message, SpinnerService, UtilsService } from 'shared-components';
import { CultivosContextService } from '../../context/cultivos-context.service';
import { CultivosService } from '../../services/cultivos.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-mantenimiento-cultivos',
    templateUrl: './mantenimiento-cultivos.component.html'
})
export class MantenimientoCultivosComponent implements OnInit, OnDestroy {

    private readonly _DEFAULT_ITEMS_PER_PAGE = 10;
    public _filters;
    private _filtersDropdown;
    public filtersVisible = false;
    public filtersForm: UntypedFormGroup;
    public dropdownInfo: number;
    public dropdownSection: number;
    public fincasList;
    public totalesFincas;
    public fincaId;
    public mensajes = new Array<Message>();
    public showError: boolean;
    public showWarning: boolean;
    public newEditModal = false;
    public deleteModal = false;
    public geometryModal = false;
    // Para guardar si se continúa o no con la modificación de la provincia/municipio si hay geometría
    public parentProvinciaMunicipioCambio = false;
    public pestanaActiva = new Array<number>();
    public setVisible;

    public provincias;
    public municipios;
    public denominaciones;
    public campanyas;

    public toEditId;
    public toDeleteId;
    public toCloseSpinner = 0;

    public refreshCheckbox_visible = false;
    public refreshCheckbox_fincaDePrueba = false;
    public refreshCheckbox_fincaCultivoCH = false;
    public refreshCheckbox_fincaDesignacionCH = false;
    public refreshCheckbox_tieneGeometria = false;


    public itemsPerPage = this._DEFAULT_ITEMS_PER_PAGE;
    public currentPage = 0; // La paginacion en back empieza por 0, como los arrays.
    public totalItems: number;
    public readonly visiblePages = 3;

    public disabledPais: Subject<boolean> = new Subject();
    public disabledProvincia: Subject<boolean> = new Subject();
    public disabledMunicipio: Subject<boolean> = new Subject();
    public disabledDenominacion: Subject<boolean> = new Subject();
    public disabledCampanya: Subject<boolean> = new Subject();

    public orderBy: string;
    public columnId: number;
    public columnToSort: string; // Ordenación pdf/excel
    public columnOrder: boolean;
    public exportModal = 0;
    public fileType: string; // 'Pdf' / 'Excel' / 'Csv'

    public csvImportModal = false;
    public csvStep = 'initial';

    private readonly destroy$ = new Subject<void>();

    constructor(
        private _fb: UntypedFormBuilder,
        private readonly _translate: TranslateService,
        private readonly _sessionContext: SessionContextService,
        private readonly _spinnerService: SpinnerService,
        private readonly _cultivosService: CultivosService,
        private readonly _cultivosContext: CultivosContextService,
        private readonly _dataProvider: DataProvider,
        private readonly _router: Router,
        public readonly utilsService: UtilsService
    ) { }


    ngOnInit() {

        if (this.role !== 'Administrador') {
            this.setVisible = true;
        }

        this.filtersForm = this._fb.group({
            pais: [''],
            provincia: [{ value: '', disabled: true }],
            municipio: [{ value: '', disabled: true }],
            fechaInicio: [''],
            fechaFin: [''],
            dateType: ['false'],
            des: [''],
            visible: [this.setVisible],
            fincaDePrueba: [''],
            fincaCultivoCH: [''],
            fincaDesignacionCH: [''],
            fechaInicioCultivos: [''],
            fechaFinCultivos: [''],
            dateTypeCultivos: ['false'],
            denominacion: [{ value: '', disabled: true }],
            nPlantasMin: [''],
            nPlantasMax: [''],
            aforoMin: [''],
            aforoMax: [''],
            superficieMin: [''],
            superficieMax: [''],
            alturaNivelMarMin: [''],
            alturaNivelMarMax: [''],
            campanya: [{ value: '', disabled: true }],
            desProductor: [''],
            nLicencia: [''],
            poligonoCatastro: [''],
            parcelaCatastro: [''],
            tieneGeometria: ['']
        });
        this._cultivosContext.mantenimientoCultivosFilters = null;

        this.getCultivosYTotales();

        this.filtersForm.get('fechaInicio').valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => this.validDates());
        this.filtersForm.get('fechaFin').valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => this.validDates());

        this.filtersForm.get('fechaInicioCultivos').valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => this.validDates());
        this.filtersForm.get('fechaFinCultivos').valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => this.validDates());

        this.filtersForm.get('denominacion').valueChanges.pipe(takeUntil(this.destroy$)).subscribe((denominacion) => {
            if (denominacion) {
                this.getCampanyasByDenominacion(denominacion.id, this.filtersForm.get('pais').value.id);
            } else {
                this.disabledCampanya.next(true);
                this.campanyas = [];
                this.filtersForm.get('campanya').patchValue('');
                this.filtersForm.get('campanya').disable();
            }
        });

        this.filtersForm.get('pais').valueChanges.pipe(takeUntil(this.destroy$)).subscribe((pais) => {
            if (pais) {
                this._filtersDropdown = {
                    paisId: pais.id
                };
                this._spinnerService.showSpinner();
                this.toCloseSpinner += 1;
                this._cultivosService.getProvinciasPais(this._filtersDropdown).toPromise().finally(() => {
                    this.checkCloseSpinner();
                }).then((resp) => {
                    if (resp.lista.length > 0) {
                        this.provincias = resp.lista;
                        this.disabledProvincia.next(false);
                    }
                });

                this._spinnerService.showSpinner();
                this.toCloseSpinner += 1;
                this._cultivosService.getDenominacionesByPaisId(this._filtersDropdown).toPromise().finally(() => {
                    this.checkCloseSpinner();
                }).then((resp) => {
                    if (resp.lista.length > 0) {
                        this.denominaciones = resp.lista;
                        if (this.denominaciones.length === 1) {
                            this.filtersForm.get('denominacion').patchValue(this.denominaciones[0]);
                        }
                        this.filtersForm.get('denominacion').enable();
                        this.disabledDenominacion.next(false);
                    }
                });
            } else {
                this.provincias = null;
                this.municipios = null;
                this.denominaciones = null;
                this.disabledProvincia.next(true);
                this.disabledMunicipio.next(true);
                this.disabledDenominacion.next(true);
                this.filtersForm.get('municipio').reset();
                this.filtersForm.get('provincia').reset();
                this.filtersForm.get('denominacion').reset();
            }
        });

        this.filtersForm.get('provincia').valueChanges.pipe(takeUntil(this.destroy$)).subscribe((provincia) => {
            if (provincia) {
                this._filtersDropdown = {
                    provinciaId: provincia.id
                };
                this._spinnerService.showSpinner();
                this.toCloseSpinner += 1;
                this._cultivosService.getMunicipiosProvincia(this._filtersDropdown).toPromise().finally(() => {
                    this.checkCloseSpinner();
                }).then((resp) => {
                    if (resp.lista.length > 0) {
                        this.municipios = resp.lista;
                        this.disabledMunicipio.next(false);
                    }
                });
            } else {
                this.municipios = null;
                this.disabledMunicipio.next(true);
                this.filtersForm.get('municipio').reset();
            }
        });

    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    public getCampanyasByDenominacion(denominacionId, paisId) {
        let filters = {
            denominacionId,
            paisId,
            volcadoHistorico: false
        };
        this._spinnerService.showSpinner();
        this.toCloseSpinner += 1;
        this._cultivosService.getCampanyas(filters).toPromise().finally(() => {
            this.checkCloseSpinner();
        }).then((resp) => {
            if (resp.lista.length > 0) {
                this.campanyas = resp.lista;
                this.campanyas.forEach(campanya => {
                    campanya.des = campanya.anyo.toString();
                });
                this.filtersForm.get('campanya').patchValue(this.campanyas[0]);
                this.filtersForm.get('campanya').enable();
                this.disabledCampanya.next(false);
            }
        });
    }

    public get defaultLanguage() {
        return this._translate.getDefaultLang();
    }

    public get paises() {
        if (this._dataProvider.paises) {
            if (this._dataProvider.paises.length === 1 && this.filtersForm.get('pais').enabled) {
                this.filtersForm.get('pais').patchValue(this._dataProvider.paises[0]);
                this.filtersForm.get('pais').disable();
            }
        }
        return this._dataProvider.paises;
    }

    public get cultivos() {
        return this._dataProvider.cultivos;
    }

    public get role() {
        return this._sessionContext.sessionUser.role;
    }

    public get claims() {
        return this._sessionContext.sessionUser.lsClaimTypes;
    }

    public get isSmallScreen(){
      return this._sessionContext.isSmallScreen();
    }

    public get idiomaId(){
      return this._sessionContext.sessionUser.idiomaId;
    }

    public pageChange(page) {
        this.dropdownInfo = -1;
        this.dropdownSection = -1;
        this._cultivosContext.mantenimientoCultivosFilters.numPagina = this.currentPage = page - 1;
        this.getCultivosYTotales();
    }

    public itemsPerPageChange(items) {
        this.dropdownInfo = -1;
        this.dropdownSection = -1;
        this._cultivosContext.mantenimientoCultivosFilters.numPagina = this.currentPage = 0;
        this._cultivosContext.mantenimientoCultivosFilters.tamPagina = this.itemsPerPage = items;
        this.getCultivosYTotales();
    }

    private clearDatesValidators(fechaInicio, fechaFin) {
        if (this.filtersForm.get(fechaFin).errors && this.filtersForm.get(fechaFin).errors.includes('Invalid date')) {
            this.filtersForm.get(fechaFin).clearValidators();
            this.filtersForm.get(fechaFin).updateValueAndValidity();
        }
        if (this.filtersForm.get(fechaInicio).errors && this.filtersForm.get(fechaInicio).errors.includes('Invalid date')) {
            this.filtersForm.get(fechaInicio).clearValidators();
            this.filtersForm.get(fechaInicio).updateValueAndValidity();
        }
    }

    private checkDates(inicio, fin) {
        const inicioD = new Date(inicio);
        const finD = new Date(fin);
        return inicioD <= finD;
    }

    private checkDatePair(fechaInicio, fechaFin) {
        if (this.filtersForm.get(fechaInicio).value && this.filtersForm.get(fechaFin).value) {
            if (this.checkDates(this.filtersForm.get(fechaInicio).value, this.filtersForm.get(fechaFin).value)) {
                this.clearDatesValidators(fechaInicio, fechaFin);
            } else {
                this.filtersForm.get(fechaInicio).setErrors(['Invalid date']);
                this.filtersForm.get(fechaFin).setErrors(['Invalid date']);
            }
        } else {
            this.clearDatesValidators(fechaInicio, fechaFin);
        }
    }

    public validDates() {
        this.checkDatePair('fechaInicio', 'fechaFin');
        this.checkDatePair('fechaInicioCultivos', 'fechaFinCultivos');

        if (this.filtersForm.get('fechaInicio').invalid || this.filtersForm.get('fechaFin').invalid ||
            this.filtersForm.get('fechaInicioCultivos').invalid || this.filtersForm.get('fechaFinCultivos').invalid) {
            this.showError = true;
            this.mensajes.push({ class: 'error', message: 'global.fecha.error.finAnteriorInicio' });
        } else {
            this.showError = false;
            this.mensajes = [];
        }
    }

    public checkValuesForm(): boolean {
        return (this.filtersForm.get('denominacion').value ||
            (this.filtersForm.get('pais').value && this.filtersForm.get('pais').enabled) ||
            this.filtersForm.get('provincia').value ||
            this.filtersForm.get('municipio').value ||
            this.filtersForm.get('fechaInicio').value ||
            this.filtersForm.get('fechaFin').value ||
            this.filtersForm.get('fechaInicioCultivos').value ||
            this.filtersForm.get('fechaFinCultivos').value ||
            !this.filtersForm.get('visible').pristine ||
            !this.filtersForm.get('fincaDePrueba').pristine ||
            !this.filtersForm.get('fincaCultivoCH').pristine ||
            !this.filtersForm.get('fincaDesignacionCH').pristine ||
            this.filtersForm.get('des').value ||
            this.filtersForm.get('nPlantasMin').value ||
            this.filtersForm.get('nPlantasMax').value ||
            this.filtersForm.get('aforoMin').value ||
            this.filtersForm.get('aforoMax').value ||
            this.filtersForm.get('superficieMin').value ||
            this.filtersForm.get('superficieMax').value ||
            this.filtersForm.get('alturaNivelMarMin').value ||
            this.filtersForm.get('alturaNivelMarMax').value ||
            this.filtersForm.get('campanya').value ||
            this.filtersForm.get('desProductor').value ||
            this.filtersForm.get('poligonoCatastro').value ||
            this.filtersForm.get('parcelaCatastro').value ||
            this.filtersForm.get('nLicencia').value) ? true : false ||
            this.filtersForm.get('tieneGeometria').value;
    }

    public resetForm() {
        this.filtersForm.reset({
            pais: this.filtersForm.get('pais').disabled ? this.filtersForm.get('pais').value : null
        });
        this._filtersDropdown = null;
        this.filtersForm.get('dateType').patchValue('false');
        this.filtersForm.get('dateTypeCultivos').patchValue('false');
        this.refreshCheckbox_visible = true;
        this.refreshCheckbox_fincaDePrueba = true;
        this.refreshCheckbox_fincaCultivoCH = true;
        this.refreshCheckbox_fincaDesignacionCH = true;
        this.refreshCheckbox_tieneGeometria = true;
    }

    public pristineCheckbox(idForm:string, pristine:boolean){
      const form = this.filtersForm.get(idForm);
      pristine ? form.markAsPristine() : form.markAsDirty();
    }

    public filtrar() {
        this.validDates();
        if (this.filtersForm.valid) {
            this.applyFilters();
            this.dropdownInfo = -1;
            this.dropdownSection = -1;
        }
    }

    private applyFilters() {
        this.currentPage = 0;
        this._cultivosContext.mantenimientoCultivosFilters = {
            fechaInicio: this.filtersForm.get('fechaInicio').value ?
                this.utilsService.parseGMTtoYYYYMMDD(this.filtersForm.get('fechaInicio').value) : '',
            fechaFin: this.filtersForm.get('fechaFin').value ?
                this.utilsService.parseGMTtoYYYYMMDD(this.filtersForm.get('fechaFin').value) : '',
            fechaActualizacion: this.filtersForm.get('dateType').value ? this.filtersForm.get('dateType').value : false,
            paisId: this.filtersForm.get('pais').value ? this.filtersForm.get('pais').value.id : null,
            provinciaId: this.filtersForm.get('provincia').value ? this.filtersForm.get('provincia').value.id : null,
            municipioId: this.filtersForm.get('municipio').value ? this.filtersForm.get('municipio').value.id : null,
            des: this.filtersForm.get('des').value ? this.filtersForm.get('des').value : '',
            visible: this.filtersForm.get('visible').value ? this.filtersForm.get('visible').value : null,
            fincaDePrueba: this.filtersForm.get('fincaDePrueba').value ? this.filtersForm.get('fincaDePrueba').value : null,
            cargaRegistroEnUso: true,
            fincaCultivoCampanyaHabilitada: this.filtersForm.get('fincaCultivoCH').value ? this.filtersForm.get('fincaCultivoCH').value : null,
            fincaDesignacionCampanyaHabilitada: this.filtersForm.get('fincaDesignacionCH').value ? this.filtersForm.get('fincaDesignacionCH').value : null,
            filtroCultivo: {
                paisId: this.filtersForm.get('denominacion').value ? (this.filtersForm.get('pais').value ? this.filtersForm.get('pais').value.id : null) : null,
                fechaInicio: this.filtersForm.get('fechaInicioCultivos').value ?
                    this.utilsService.parseGMTtoYYYYMMDD(this.filtersForm.get('fechaInicioCultivos').value) : '',
                fechaFin: this.filtersForm.get('fechaFinCultivos').value ?
                    this.utilsService.parseGMTtoYYYYMMDD(this.filtersForm.get('fechaFinCultivos').value) : '',
                fechaActualizacion: this.filtersForm.get('dateTypeCultivos').value ? this.filtersForm.get('dateTypeCultivos').value : false,
                nPlantasMin: this.filtersForm.get('nPlantasMin').value ? this.filtersForm.get('nPlantasMin').value : null,
                nPlantasMax: this.filtersForm.get('nPlantasMax').value ? this.filtersForm.get('nPlantasMin').value : null,
                aforoMin: this.filtersForm.get('aforoMin').value ? this.filtersForm.get('aforoMin').value : null,
                aforoMax: this.filtersForm.get('aforoMax').value ? this.filtersForm.get('aforoMax').value : null,
                superficieMin: this.filtersForm.get('superficieMin').value ? this.filtersForm.get('superficieMin').value : null,
                superficieMax: this.filtersForm.get('superficieMax').value ? this.filtersForm.get('superficeMax').value : null,
                alturaNivelMarMin: this.filtersForm.get('alturaNivelMarMin').value ? this.filtersForm.get('alturaNivelMarMin').value : null,
                alturaNivelMarMax: this.filtersForm.get('alturaNivelMarMax').value ? this.filtersForm.get('alturaNivelMarMax').value : null,
                campanyaId: this.filtersForm.get('campanya').value ? this.filtersForm.get('campanya').value.id : null,
                denominacionId: this.filtersForm.get('denominacion').value ? this.filtersForm.get('denominacion').value.id : null,
                desProductor: this.filtersForm.get('desProductor').value ? this.filtersForm.get('desProductor').value : '',
                poligonoCatastro: this.filtersForm.get('poligonoCatastro').value ? this.filtersForm.get('poligonoCatastro').value : '',
                parcelaCatastro: this.filtersForm.get('parcelaCatastro').value ? this.filtersForm.get('parecelaCatastro').value : '',
                nLicencia: this.filtersForm.get('nLicencia').value ? this.filtersForm.get('nLicencia').value : '',
                tieneGeometria: this.filtersForm.get('tieneGeometria').value ? this.filtersForm.get('tieneGeometria').value : null,
            },
            numPagina: this.currentPage,
            tamPagina: this.itemsPerPage,
        };
        if(this.controlFilterCultivoNulo()) this._cultivosContext.mantenimientoCultivosFilters.filtroCultivo = null;
        this.getCultivosYTotales();
    }

    public controlFilterCultivoNulo(){
      const keysFilterCultivo_ = Object.keys(this._cultivosContext.mantenimientoCultivosFilters.filtroCultivo);
      const index_ = keysFilterCultivo_.indexOf('fechaActualizacion');
      const values_ = Object.values(this._cultivosContext.mantenimientoCultivosFilters.filtroCultivo);
      return (values_.filter((element, index) => index !== index_)).every(a => a == null || a == '');
    }

    public getCultivosYTotales() {
        if (this._cultivosContext.mantenimientoCultivosFilters) {
            this._filters = this._cultivosContext.mantenimientoCultivosFilters;
        } else {
            this.applyFilters();
        }

        this.getCultivos();
        this.getTotales();
    }

    public getCultivos() {
        this._spinnerService.showSpinner();
        this.toCloseSpinner += 1;
        this._filters.cargaRegBlockchainCultivo = true;
        this._cultivosService.getFincas(this._filters).toPromise().finally(() => {
            this.checkCloseSpinner();
        }).then((resp) => {
            this.totalItems = resp.paginacionMeta.totalCount;
            this.fincasList = resp.lista;
        }, (error) => {
            this.pushMessage('global.error.noResponse');
        });
    }

    public getTotales() {
        // this._spinnerService.showSpinner();
        // this.toCloseSpinner += 1;
        this.totalesFincas = undefined;
        this._cultivosService.getTotalesFincas(this._filters).toPromise().finally(() => {
            // this.checkCloseSpinner();
        }).then((resp) => {
            this.totalesFincas = resp;
        });
    }

    public create() {
        this.fincaId = null;
        this.newEditModal = true;
    }

    public update(finca) {
        this.fincaId = finca.id;
        this.newEditModal = true;
    }

    public delete() {
        this._spinnerService.showSpinner();
        this.toCloseSpinner += 1;
        this._cultivosService.deleteFinca(this.fincaId).toPromise().finally(() => {
            this.checkCloseSpinner();
        }).then(() => {
            this.close();
            this.pushMessage('global.success.itemDeleted');
            this.getCultivosYTotales();
        });
    }

    public askDelete(finca) {
        this.fincaId = finca.id;
        this.deleteModal = true;
    }

    public close() {
        this.deleteModal = false;
        this.newEditModal = false;
    }

    public pushMessage(mensaje) {
        this.showError = true;
        if (mensaje.includes('error') || mensaje.includes('ApiErrors')) {
            this.mensajes.push({ class: 'error', message: mensaje });
        } else {
            this.mensajes.push({ class: 'success', message: mensaje });
        }
    }

    public refresh(value) {
        this.newEditModal = false;
        if (value) {
            this.getCultivosYTotales();
        }
    }

    public showDetails(i: number) {
        this.dropdownInfo = this.dropdownInfo === i ? -1 : i;
    }

    public openTabs(i) {
        this.dropdownSection = this.dropdownSection === i ? -1 : i;
        this.pestanaActiva[i] = this.pestanaActiva[i] > 0 ? this.pestanaActiva[i] : 1;
        // Desplazamiento a la izquierda para tablet (mismo tamaño máx. que en table.scss)
        if (this.dropdownSection !== -1 && window.innerWidth <= 1199) {
            // Retardo: en caso de que haya otro detalle abierto
            setTimeout(() => {
                document.querySelector('table')?.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'start'});
            }, 50);
        }
    }

    public showCultivos(i) {
        this.pestanaActiva[i] = 1;
    }

    public showDesignaciones(i) {
        this.pestanaActiva[i] = 2;
    }

    private checkCloseSpinner() {
        this.toCloseSpinner -= 1;
        if (this.toCloseSpinner === 0) {
            this._spinnerService.hideSpinner();
        }
    }

    public showCatastro(): boolean {
        return this._dataProvider.paises.some((a: any) => a.id === 1);
    }

    public getIcon(prop: string, idColumn: number) {
      let iconClass = 'fa fa-sort';
      if (this._filters && this._filters.orderItems && this._filters.orderItems[0].orderProperty.indexOf(prop) != -1 && this.columnId === idColumn) {
          iconClass = this._filters.orderItems[0].orderByDescending === true ? 'fa fa-sort-down' : 'fa fa-sort-up';
      }
      return iconClass;
    }

    public toOrderBy(columnFilter, idColumn) {
        this.columnToSort = columnFilter;
        this.columnId = idColumn;
        if (this.fincasList && this.fincasList.length > 0) {
          if (this._cultivosContext.mantenimientoCultivosFilters) {
            this._filters = this._cultivosContext.mantenimientoCultivosFilters;
            if (!this.orderBy || this.orderBy.includes('DESC')) {
              this.orderBy = 'ASC' + idColumn;
              this._filters.orderItems = [
                {
                  orderProperty: columnFilter,
                  orderByDescending: false
                }
              ];
              this.columnOrder = false;
            } else if (this.orderBy.includes('ASC')) {
              this.orderBy = 'DESC' + idColumn;
              this._filters.orderItems = [
                {
                  orderProperty: columnFilter,
                  orderByDescending: true
                }
              ];
              this.columnOrder = true;
            }
            this.getCultivos();
          }
        }
    }

    public export(type) {
      this.exportPdfOrCsv(type);
      this.exportModal = 0;
    }

    public prepareReportForSorting() {
        this._filters.orderItems = [
            {
                orderProperty: this.columnToSort,
                orderByDescending: this.columnOrder
            }
        ]
    }

    public exportPdfOrCsv(type:number){
        if (this.fincasList && this.fincasList.length > 0) {

            switch (this.exportModal) {
                case 1:
                    this.fileType = 'Pdf';
                    break;
                case 3:
                    this.fileType = 'Csv';
                    break;
            }

            if (this._cultivosContext.mantenimientoCultivosFilters) {
                this._filters = this._cultivosContext.mantenimientoCultivosFilters;
                this._filters.tamPagina = 0;
                this._filters.tipoArchivo = this.fileType;
                this._filters.mostrarDetalle = type === 1 ? false : true;

                // Si se había ordenado alguna columna de la tabla
                if (this.columnToSort) {
                    this.prepareReportForSorting();
                }
            }

            this._spinnerService.showSpinner();
            this.toCloseSpinner += 1;

            switch (this.fileType) {
                case 'Pdf':
                    this.downloadPdf();
                    break;
                case 'Csv':
                    this.downloadCsv();
                    break;
            }
        } else {
            this.mensajes.push({ class: 'error', message: 'global.error.exportNoData' });
        }
    }

    private downloadCsv() {
        this._cultivosService.getCsvCultivosReport(this._filters).toPromise().finally(() => {
                this.checkCloseSpinner();
            }).then((resp) => {
                const downloadLink = document.createElement('a');
                downloadLink.href = 'data:text/csv;base64,' + resp.base64Archivo;
                downloadLink.download = resp.nombreArchivo;
                downloadLink.click();
            },
            (error) => {
                this.showError = true;
                this.mensajes.push({ class: 'error', message: 'global.error.file' });
            }
        );
    }

    private downloadPdf() {
        this._cultivosService.getCultivosReport(this._filters).toPromise().finally(() => {
            this.checkCloseSpinner();
            }).then((resp) => {
                const downloadLink = document.createElement('a');
                downloadLink.href = 'data:application/pdf;base64,' + resp.base64Archivo;
                downloadLink.download = resp.nombreArchivo;
                downloadLink.click();
            },
            (error) => {
                this.showError = true;
                this.mensajes.push({ class: 'error', message: 'global.error.file' });
            }
        );
    }

    public openDocHelp() {
        this._spinnerService.showSpinner();
        this.toCloseSpinner += 1;
        this._cultivosService.getDocHelp('Crops_Crops.pdf').toPromise().finally(() => {
            this.checkCloseSpinner();
        }).then((resp) => {
            localStorage.setItem('base64', resp.base64Archivo);
            const url = this._router.serializeUrl(this._router.createUrlTree(['viewPdf']));
            window.open(url, '_blank');
        });
    }

    /**
     * Mostrar el modal de continuar con la edición de provincia/municipio de la finca
     * cuando el cultivo tiene una geometría asociada
     * 
     * @param value Output de new-edit (refreshGeometryModal)
     */
    public showGeometryModal(value: boolean) {
        this.geometryModal = value;
    }

    /**
     *  Continuar con la edición de provincia/municipio
     */
    public continueOrCancelModification(continueOrCancel: string) {
        switch (continueOrCancel) {
            case 'accept':
                this.parentProvinciaMunicipioCambio = true;
                break;
            case 'cancel':
                this.parentProvinciaMunicipioCambio = false;
                this.geometryModal = false;
                break;
        }
    }

    public refreshParentProvinciaMunicipio(value) {
        this.parentProvinciaMunicipioCambio = value;
    }

    public showCsvImportModal() {
        this.csvImportModal = true;
    }

    public hideCsvModal(value: string) {
        this.csvImportModal = false;

        switch (value) {
            case 'open-form':
                this.fincaId = null;
                this.newEditModal = true;
                break;
            case 'refresh-page':
                this.getCultivosYTotales();
                break;
        }
    }

    public getCsvModalClass() {
        return `csv-${this.csvStep}-parent`;
    }

    public trackByFincaId(index: number, finca: { id: number }): number {
        return finca.id;
    }
}